import React from 'react';

const Footer = () => {
	return (
		<div className='footer'>
			<div className='line'></div>
			<p>books</p>
			<p>audiobooks</p>
			<p>Stationery & gifts</p>
			<p>blog</p>
		</div>
	);
};

export default Footer;
